(() => {
  const notice = document.getElementById('cookie-notice');
  if (!notice) return;
  const key = 'stabledays:cookie-notice:v1';
  let dismissed = false;
  try { dismissed = localStorage.getItem(key) === 'dismissed'; } catch {}
  notice.hidden = dismissed;
  document.getElementById('cookie-dismiss').addEventListener('click', () => {
    notice.hidden = true;
    try { localStorage.setItem(key, 'dismissed'); } catch {}
  });
})();
